import { useCallback, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLlcApi } from '../Api';

interface EssentialLoginProfileDto {
  id: number;
  hasIndividual: boolean;
  residenceState: string | null;
}

interface LoginProfileState {
  profile: EssentialLoginProfileDto | null;
  loading: boolean;
  error: boolean;
}

export function useLoginProfile(): LoginProfileState {
  const { isAuthenticated } = useAuth0();
  const llcApi = useLlcApi();
  const [state, setState] = useState<LoginProfileState>({
    profile: null,
    loading: true,
    error: false,
  });

  const load = useCallback(
    async (signal: AbortSignal) => {
      setState((s) => ({ ...s, loading: true, error: false }));
      try {
        const response = await llcApi.get<EssentialLoginProfileDto>(
          '/api/LoginProfile',
          { signal }
        );
        setState({ profile: response.data, loading: false, error: false });
      } catch {
        if (signal.aborted) return;
        setState({ profile: null, loading: false, error: true });
      }
    },
    [llcApi]
  );

  useEffect(() => {
    if (!isAuthenticated) return;
    const controller = new AbortController();
    load(controller.signal);
    return () => controller.abort();
  }, [load, isAuthenticated]);

  return state;
}
